var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("scroll-bar", {
    staticClass: "shopRank-wrapper all-container"
  }, [_vm.rankData.length != 0 ? _c("vue-seamless-scroll", {
    key: _vm.num,
    attrs: {
      data: _vm.rankData,
      "class-option": _vm.classOption
    }
  }, _vm._l(_vm.rankData, function (item, index) {
    return _c("div", {
      key: index + _vm.num + item.value,
      staticClass: "shop-item flex"
    }, [_c("div", {
      staticStyle: {
        width: "130px",
        display: "flex"
      }
    }, [_c("span", {
      staticClass: "rankIndex inline-block"
    }, [index < 3 ? _c("svg-icon", {
      attrs: {
        icon: _vm.rankIndex[index + 1],
        size: 30
      }
    }) : _c("span", [_vm._v(" " + _vm._s(index + 1))])], 1), _c("span", {
      staticStyle: {
        "margin-left": "10px",
        overflow: "hidden",
        "text-overflow": "ellipsis",
        flex: "1",
        "white-space": "nowrap"
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "topLeft"
      }
    }, [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.area.replace("保险", _vm.$t("保险"))) + " ")]), _vm._v(" " + _vm._s(item.area.replace("保险", _vm.$t("保险"))) + " ")], 2)], 1)]), _c("a-progress", {
      staticClass: "flex-sub",
      attrs: {
        "stroke-color": {
          from: "#3dadf6",
          to: "#737bfc"
        },
        percent: _vm.filterValue(item.value),
        showInfo: false
      }
    }), _c("div", {
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_vm._v(_vm._s(item.value))])], 1);
  }), 0) : _c("div", [_c("a-result", {
    attrs: {
      title: _vm.$t("暂无数据")
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c("a-icon", {
          attrs: {
            type: "exclamation-circle"
          }
        })];
      },
      proxy: true
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };